import React, { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import api from "../../api";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GradeRulesPage = () => {
    const [form, setForm] = useState({
        scale_type: "",
        min_percentage: "",
        max_percentage: "",
        grade: "",
        remarks: ""
    });

    const [items, setItems] = useState([]);
    const [editId, setEditId] = useState(null);

    const baseURL = "/grade_rules";

    // Fetch Grade Rules
    const fetchRules = async () => {
        try {
            const res = await api.get(`${baseURL}/list`);
            const list = res.data?.data ?? [];
            setItems(Array.isArray(list) ? list : []);
        } catch (err) {
            toast.error("Failed to fetch grade rules ❌");
        }
    };

    useEffect(() => {
        fetchRules();
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.scale_type || !form.min_percentage || !form.max_percentage || !form.grade) {
            return toast.error("All required fields must be filled ❌");
        }

        try {
            let res;
            if (editId) {
                res = await api.post(`${baseURL}/update`, { ...form, id: editId });
            } else {
                res = await api.post(`${baseURL}/create`, form);
            }

            if (res.data?.status) {
                toast.success(
                    res.data.message ||
                    (editId ? "Updated successfully 🎉" : "Added successfully ✅")
                );
            } else {
                toast.error(res.data?.message || "Operation failed ❗");
            }

            setForm({
                scale_type: "",
                min_percentage: "",
                max_percentage: "",
                grade: "",
                remarks: ""
            });
            setEditId(null);
            fetchRules();

        } catch (err) {
            toast.error(err.response?.data?.message || "Network error ❌");
        }
    };

    const handleEdit = (item) => {
        setForm({
            scale_type: item.scale_type || "",
            min_percentage: item.min_percentage || "",
            max_percentage: item.max_percentage || "",
            grade: item.grade || "",
            remarks: item.remarks || ""
        });

        setEditId(item.id);
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.info("Edit mode enabled ✏️");
    };

    return (
        <div style={{ display: "flex", minHeight: "100vh" }}>
            <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>
                <main style={{ padding: "30px", maxWidth: "1000px", margin: "auto" }}>

                    {/* Add/Edit Grade Form */}
                    <section style={cardStyle}>
                        <h2 style={titleStyle}>
                            {editId ? "✏️ Edit Grade Rule" : "➕ Add Grade Rule"}
                        </h2>

                        <form onSubmit={handleSubmit}>
                            <div style={formGrid}>

                                <FormGroup label="Scale Type (e.g. 100)">
                                    <input
                                        type="text"
                                        name="scale_type"
                                        value={form.scale_type}
                                        onChange={handleChange}
                                        style={fullWidthInput}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup label="Minimum Percentage">
                                    <input
                                        type="number"
                                        name="min_percentage"
                                        value={form.min_percentage}
                                        onChange={handleChange}
                                        style={fullWidthInput}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup label="Maximum Percentage">
                                    <input
                                        type="number"
                                        name="max_percentage"
                                        value={form.max_percentage}
                                        onChange={handleChange}
                                        style={fullWidthInput}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup label="Grade (e.g. A, A+, B)">
                                    <input
                                        type="text"
                                        name="grade"
                                        value={form.grade}
                                        onChange={handleChange}
                                        style={fullWidthInput}
                                        required
                                    />
                                </FormGroup>

                                <FormGroup label="Remarks (optional)" style={twoColumnFull}>
                                    <input
                                        type="text"
                                        name="remarks"
                                        value={form.remarks}
                                        onChange={handleChange}
                                        style={fullWidthInput}
                                    />
                                </FormGroup>

                            </div>

                            <div style={{ textAlign: "right", marginTop: "20px" }}>
                                <button type="submit" style={buttonStyle}>
                                    {editId ? "Update Rule" : "Add Rule"}
                                </button>
                            </div>
                        </form>
                    </section>

                    {/* Grade Rules Table */}
                    <section style={cardStyle}>
                        <h2 style={titleStyle}>📋 All Grade Rules</h2>

                        {items.length === 0 ? (
                            <p>No grade rules found.</p>
                        ) : (
                            <div style={{ overflowX: "auto" }}>
                                <table style={tableStyle}>
                                    <thead>
                                        <tr>
                                            <th style={thStyle}>Grade</th>
                                            <th style={thStyle}>Scale Type</th>
                                            <th style={thStyle}>Range (%)</th>
                                            <th style={thStyle}>Remarks</th>
                                            <th style={thStyle}>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.map((item) => (
                                            <tr key={item.id} style={trStyle}>
                                                <td style={tdStyleCenter}>{item.grade}</td>

                                                <td style={tdStyle}>
                                                    <span style={badgeStyle}>
                                                        {item.scale_type}
                                                    </span>
                                                </td>

                                                <td style={tdStyleCenter}>
                                                    {item.min_percentage}% - {item.max_percentage}%
                                                </td>

                                                <td style={tdStyle}>
                                                    {item.remarks || "—"}
                                                </td>

                                                <td style={tdStyleCenter}>
                                                    <FaEdit
                                                        onClick={() => handleEdit(item)}
                                                        style={{ color: "#0077cc", cursor: "pointer", fontSize: "18px" }}
                                                        title="Edit Grade Rule"
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </section>

                    {/* Toast container */}
                    <ToastContainer position="top-right" autoClose={3000} />
                </main>
            </div>
        </div>
    );
};

const twoColumnFull = { gridColumn: "1 / 3" };

const formGrid = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px 10px",
    alignItems: "center",
};

const fullWidthInput = {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "8px",
    border: "1px solid #d0d7de",
    fontSize: "15px",
    background: "#f8faff",
    boxSizing: "border-box",
};

const FormGroup = ({ label, children, style }) => (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
        <label style={{ marginBottom: "6px", fontWeight: 600, fontSize: "14px", color: "#333" }}>
            {label}
        </label>
        {children}
    </div>
);

const buttonStyle = {
    padding: "10px 25px",
    backgroundColor: "#0077cc",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    cursor: "pointer",
};

const cardStyle = {
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    marginBottom: "30px",
};

const titleStyle = {
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "20px",
    color: "#1a1a1a",
};

const tableStyle = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 10px",
};

const thStyle = {
    textAlign: "center",
    padding: "12px 14px",
    fontSize: "14px",
    fontWeight: "700",
    color: "#444",
    background: "#f3f6fc",
    borderBottom: "2px solid #e0e6f0",
};

const trStyle = {
    background: "#ffffff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    borderRadius: "10px",
    transition: "0.25s",
};

const tdStyle = {
    padding: "14px 16px",
    fontSize: "14px",
    color: "#333",
};

const tdStyleCenter = {
    ...tdStyle,
    textAlign: "center",
};

const badgeStyle = {
    background: "#e8f2ff",
    color: "#0077cc",
    padding: "4px 10px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
};



export default GradeRulesPage;
